module.exports = __webpack_public_path__ + "static/img/6.bfd7b79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/6.jpg
// module id = dUhC
// module chunks = 1